import { createFileRoute } from '@tanstack/react-router';
import { PlanoConfigPage } from '@/components/plano';

export const Route = createFileRoute('/_app/configuracoes/plano')({
  component: PlanoConfigRota,
});

function PlanoConfigRota() {
  return <PlanoConfigPage />;
}
